import e from "./ghl-ui.es1260.js";
import i from "./ghl-ui.es416.js";
import a from "./ghl-ui.es420.js";
function f(r) {
  return a(r) ? e(r) : i(r);
}
export {
  f as default
};
